// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/ApprovalDelegation.yaml
// Generated: 2026-02-28T16:35:54.810Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateApprovalDelegation, UpdateApprovalDelegation, ApprovalDelegation } from '@/types/workflow/ApprovalDelegation';

/**
 * ApprovalDelegation Service
 * CRUD operations for ApprovalDelegation via the ABP API.
 */
export const approvalDelegationService = new EntityService<ApprovalDelegation, CreateApprovalDelegation, UpdateApprovalDelegation>(
  '/api/workflow/approvaldelegation',
  'ApprovalDelegation',
);
